import { useRoutes } from 'react-router-dom';
import routeConfig from './routes/route-config';
import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import "./index.css";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import theme from './theme';
import { ThemeProvider } from '@emotion/react';
import { analytics } from "./firebase"; 
import { logEvent } from "firebase/analytics";

const App = () => {
  // ScrollToTop component
  const ScrollToTop = () => {

    const { pathname, hash } = useLocation();

    useEffect(() => {
      // if there is a hash, scroll to the element
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Otherwise, scroll
        // window.scrollTo(0, 0);
        document.getElementById('main').scrollTo(0, 0)
      }
    }, [pathname, hash]);

    return null;
  };

  useEffect(() => {
    logEvent(analytics, "page_view"); // 记录页面浏览事件
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className='flex flex-col h-screen'>
        <ScrollToTop />
        <Navbar />
        {/* This id will be quered by NavBar */}
        <main id='main' className='flex-1 overflow-y-scroll'>
          {useRoutes(routeConfig)}
          <Footer />
        </main>
      </div>
    </ThemeProvider>
  );
};

export default App;
